function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "water_drop"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m12.538 2.157c-.328-.209-.748-.209-1.076 0-.305.195-7.462 4.844-7.462 11.843 0 4.411 3.589 8 8 8s8-3.589 8-8c0-6.999-7.157-11.648-7.462-11.843zm-.538 17.843c-3.309 0-6-2.691-6-6 0-4.878 4.434-8.61 6-9.776 1.566 1.166 6 4.898 6 9.776 0 3.309-2.691 6-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m16.046 14.726c-.505-.226-1.096.004-1.32.508-.3.677-.837 1.209-1.511 1.498-.507.218-.742.806-.524 1.313.163.379.532.605.919.605.131 0 .265-.026.394-.081 1.138-.488 2.044-1.385 2.55-2.523.224-.505-.003-1.096-.508-1.32z"
})));

var Svg131Waterdrop = function Svg131Waterdrop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg131Waterdrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/131-water drop.07624b88.svg";
export { ForwardRef as ReactComponent };